import React, { useCallback, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getOffersPromoPages } from '@yme/api';
import { CartEmpty } from '@yme/assets/icons';
import { Col, Container, Row } from '@yme/atoms/grid';
import { InfoBlockEmptyResults } from '@yme/atoms/info-block-empty-results';
import { Pagination, buildEmptyItemsArray, usePaginationConfig } from '@yme/atoms/pagination';
import { DIRECTION_NEXT } from '@yme/atoms/pagination/constants';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { DEFAULT_PER_PAGE_VALUES } from '@yme/common/constants';
import { useWindowSize } from '@yme/hooks/index';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { getEmptyArrayData } from '@yme/organisms/news-events-grid/helpers';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { buildKey } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { OFFERS_PROMO_GRID_ID, SCROLL_OFFSET, CARD_KEY } from './constants';
import { getOfferDate } from './helpers';
export function OffersPromoCards(props) {
    const { labels } = props;
    const isRightToLeft = useSelector(getRTL);
    const history = useHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const urlCurrentPage = Number(urlParams.get('page'));
    const [pages, setPages] = useState({
        results: [],
        currentPage: urlCurrentPage || 1,
        total: 1,
        count: 0,
        offset: 0,
        currentPerPage: Number(urlParams.get('perPage')) || 6,
    });
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    const paginationConfigData = {
        currentPage: pages.currentPage,
        perPageOptions: DEFAULT_PER_PAGE_VALUES,
        activeElement: pages.currentPerPage || 6,
        countItems: Math.floor(pages.total / (pages.limit || 1)),
        items: buildEmptyItemsArray(getEmptyArrayData(pages.total, pages.limit)),
    };
    const { paginationConfig, currentPerPageValue, setCurrentPerPageValue, onClickItemHandler } = usePaginationConfig({
        paginationData: paginationConfigData,
        isMobileView: false,
    });
    const getCurrentPage = useCallback((currentPage, currentPerPage) => Number((currentPage || 1) - 1) * Number(currentPerPage || pages.currentPerPage), [pages.currentPerPage]);
    const handleChangePerPage = (currentPerPage) => {
        history.push(`?page=1&perPage=${currentPerPage}`);
        setPages({
            ...pages,
            currentPage: 1,
            currentPerPage,
        });
        setCurrentPerPageValue(currentPerPage);
    };
    const handleChangePage = (params) => {
        let currentPage;
        const direction = params?.item?.direction;
        if (direction) {
            currentPage = direction === DIRECTION_NEXT ? pages.currentPage + 1 : pages.currentPage - 1;
        }
        else {
            currentPage = params?.item?.value;
        }
        if (!params.isDisabled) {
            history.push(`?page=${currentPage}&perPage=${pages.currentPerPage}`);
            setPages({
                ...pages,
                currentPage: currentPage || 1,
            });
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onClickItemHandler(params);
        }
    };
    useEffect(() => {
        (async () => {
            try {
                const offset = getCurrentPage(pages.currentPage);
                const result = await getOffersPromoPages(props?.currentPagePath, pages.currentPerPage, offset);
                setPages({
                    ...result?.data,
                    ...{
                        currentPerPage: pages.currentPerPage,
                        currentPage: pages.currentPage,
                    },
                });
                // TODO: (A.H.) Fix case for 'location', when 'results is empty'
                history.push(`?page=${pages.currentPage}&perPage=${pages.currentPerPage}`);
            }
            catch (err) {
                /* empty */
            }
        })();
    }, [getCurrentPage, history, pages.currentPage, pages.currentPerPage, props?.currentPagePath]);
    if (!isEmpty(pages.results)) {
        return (React.createElement(Container, { lgPt: "48px", lgPb: "48px", mdPt: "24px", mdPb: "24px", pt: "24px", pb: "24px", id: OFFERS_PROMO_GRID_ID },
            React.createElement(Row, null, pages.results.map(({ image, title, link, description, dateFrom, dateTo }, index) => (React.createElement(Col, { lg: 4, md: 4, sm: 4, smMargin: "0 0 24px", lgMargin: "0 0 56px", key: buildKey(CARD_KEY, index) },
                React.createElement(CardForEvents, { isRightToLeft: isRightToLeft, cardProps: {
                        image,
                        title,
                        description,
                        link,
                        labelLink: t('common_readMore_link'),
                        caption: getOfferDate(dateFrom, dateTo, labels),
                        aspectRatio: AspectRatio.RectangleLevel3,
                        countLineVisible: 'initial',
                        isFullHeaderVisible: true,
                    } }))))),
            React.createElement(Row, null,
                React.createElement(Pagination, { isRightToLeft: isRightToLeft, isMobileView: isMobileView, paginationData: paginationConfigData, paginationConfig: paginationConfig, activeItemValue: pages?.currentPage, onClickItemHandler: handleChangePage, isSizeChanged: true, perPageLabel: labels?.filters_itemsPerPage_label, currentPerPageValue: currentPerPageValue, setCurrentPerPageValue: handleChangePerPage, scrollToElement: {
                        id: OFFERS_PROMO_GRID_ID,
                        yOffset: SCROLL_OFFSET,
                    } }))));
    }
    const iconSize = isMobileView ? ICON_SIZE.xxl : ICON_SIZE.xxxxxl;
    return (React.createElement(FlexWrapper, { isFullWidth: true, alignItems: "center", justifyContent: "center" },
        React.createElement(InfoBlockEmptyResults, { customIcon: React.createElement(SVGIcon, { type: CartEmpty, size: iconSize }), verticalIndentTablet: "48px", titleEmptyResults: labels.offersPromoGrid_noOffersFound_text, isFullWidth: true })));
}
OffersPromoCards.displayName = 'OffersPromoCards_AEMComponent';
